<div class="home" data-testid="decim-home-container">
  <div class="top">
    <div class="top-bg">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/anper/anper-logo.webp" height="128px" />
      <h1>Plateforme numérique nationale</h1>
      <p class="sub-heading-text">pour la planification, l’appel d’offres et le suivi des programmes de mini-réseaux</p>

      <div class="top-images">
        <div class="top-image-container top-image-container-1">
          <h2>Information</h2>
          <p>Plus d’informations ici - Agence Nigérienne de Promotion de l’Électrification en Milieu Rural”</p>
          <div class="image-1 top-image"></div>
        </div>
        <div class="top-image-container top-image-container-2">
          <h2>Information</h2>
          <p>Plus d’informations ici - Agence Nigérienne de Promotion de l’Électrification en Milieu Rural”</p>
          <div class="image-2 top-image"></div>
        </div>
        <div class="top-image-container top-image-container-3">
          <h2>Information</h2>
          <p>Plus d’informations ici - Agence Nigérienne de Promotion de l’Électrification en Milieu Rural”</p>
          <div class="image-3 top-image"></div>
        </div>
      </div>


      <div class="middle">
        <h2>Une initiative d’ANPER en collaboration avec le PNUD et l’ASDI</h2>
      </div>

      <div class="bottom">
        <div class="bottom-logo-box">
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/anper/pnud.webp" width="392px" />
          </div>
        </div>
        <div class="bottom-logo-box">
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/anper/asdi.png" width="340px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
